import styled from "styled-components";

const EmptyMessage = styled.div`
	font-size: 14px;
	font-weight: var(--font-weight-light);
	text-align: center;
`;

export default EmptyMessage;
